import { render, staticRenderFns } from "./PrimaryBtn.vue?vue&type=template&id=5bca1ef2"
import script from "./PrimaryBtn.vue?vue&type=script&lang=js"
export * from "./PrimaryBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports